module.exports = __webpack_public_path__ + "28fac3bda88a5dc3b8d63b0dfc624641.svg";